export const GET_STATION_DATA_SUCCESS = 'GET_STATION_DATA_SUCCESS'
export const GET_NOTICE_DATA_SUCCESS = 'GET_NOTICE_DATA_SUCCESS'
export const GET_LIST_OF_AIRPORTS_SUCCESS = 'GET_LIST_OF_AIRPORTS_SUCCESS'
export const SURVEY_IS_SAVED = 'SURVEY_IS_SAVED'